import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import Tabs from '../../../../components/Tabs';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import ict from './ict@large.jpg';
import pedagogy from './pedagogy@large.jpg';

const tabs = ['教育學', '資源'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="zh" pageKey="ict-and-commitment-to-innovation">
        <h1>資訊科技及致力革新</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <p>
              京斯敦致力於校內使用電子科技推動教學及超學科探究課程的學習。使用這些科技的目的是促進合作、創作、交流、設計和研究，以及加強學生身為數碼公民的角色。本校資訊科技部為老師及學生提供技術支援，將教育科技融入日常教學之中。學校同時為教師就教育科技提供相關培訓。{' '}
            </p>
            <img src={pedagogy} alt="Pedagogy" />
          </React.Fragment>
        )}
        {tab === 1 && (
          <React.Fragment>
            <h4>一年級至三年級</h4>
            <p>
              一至三年級的學生可以使用校內提供的Macbook，Chromebook和平板電腦，方便老師運用資訊科技於教學中，促進教學。
            </p>

            <h4>四年級至六年級</h4>
            <p>
              四至六年級的學生須自備個人電腦。個人電腦有助學生提升超學科單元探究課的學習效能，同時也是二十一世紀重要的學習工具。
            </p>
            <p>
              京斯敦提倡創新教育，確保學生及老師掌握必要的學習工具及技巧，以靈活運用新科技於教學上。我們為教師提供持續的校內培訓，確保他們在科技教學上與時並進。
            </p>
            <p>
              探究課程融合科學、科技、工程、美術及音樂範疇。本校的美術及音樂課分別由經驗豐富的專科老師教授。而科學、科技及工程則融於課程中，由班主任教授，並由資訊科技部提供支援。
            </p>
            <p>此外，老師可按需要借用校內的STEM/STEAM資源，例如Beebots、Makey Makeys、Make-dos等。</p>
            <img src={ict} alt="ICT & commitment to innovation" />
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
